import React from 'react';
import { PortalContext, TPortalContextValue } from './context';
import { WithContext } from '@src/api';

type PropsProvider = {
  children: JSX.Element;
  value: TPortalContextValue;
};

export const PortalProvider: React.FC<PropsProvider> = ({ children, value }) => {
  return (
    <PortalContext.Provider
      value={{
        ...value,
        module: value?.module || '',
        companyId: value?.companyId || null,
        companyAddressId: value?.companyAddressId || null,
      }}
    >
      <WithContext>{children}</WithContext>
    </PortalContext.Provider>
  );
};
